import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import ServicesPage from "./pages/Services";
import BookPage from "./pages/Book";
import ContactPage from "./pages/Contact";
import WealthManagement from "./pages/WealthManagement";
import Insurance from "./pages/Insurance";
import SupplementPlans from "./pages/SupplementPlans";
import CreditEducation from "./pages/CreditEducation";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/wealth-management" element={<WealthManagement />} />
          <Route path="/services/insurance" element={<Insurance />} />
          <Route path="/services/supplement-plans" element={<SupplementPlans />} />
          <Route path="/services/credit-education" element={<CreditEducation />} />
          <Route path="/book" element={<BookPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
